import { Reducer } from 'redux';
import { Action, ActionType } from '../../actions';
import { TableData } from '../../state/VccCredentialsV2/TableData';

const updateTableData: Reducer<TableData> = (state: TableData = new TableData(), action: Action<ActionType, TableData>) => {
  switch (action.type) {
    case ActionType.VCC_CREDENTIALS_V2_TABLE_DATA_FETCHED:
      return { ...state, records: (action.data as any).items, totalItems: (action.data as any).totalItems };
    default:
      return state;
  }
};

export default updateTableData;
